/* nutrient-ops theme-bundle: ns-core v24 — installed by the LP Builder from nutrient-ops (website/ns-core/theme). Edit the repo copy and reinstall; hand edits here are overwritten on the next install. */
/*
 * ns-recharge.js — product pages (sections/product-page__product.liquid loads it).
 * Shows the subscription details / buyer-consent note only while "Subscribe & Save" is picked, for Recharge's
 * classic widget (.rc-purchase-option__subscription). Recharge's current widget (<recharge-subscription-widget>)
 * doesn't use that markup, so on today's pages this finds nothing and does nothing.
 * 2026-10-02: rewritten without jQuery — the old version ran $(document).ready before jQuery (deferred) had loaded
 * and threw "$ is not defined" on every product page.
 */
(function () {
  function update() {
    var sub = document.querySelector(".rc-purchase-option__subscription");
    var on = !!(sub && sub.checked);
    document.querySelectorAll(".rc-selection__root").forEach(function (el) { el.style.display = on ? "flex" : "none"; });
    document.querySelectorAll(".ns-buyer-consent").forEach(function (el) { el.style.display = on ? "block" : "none"; });
  }
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(".rc-selection__onetime, .rc-purchase-option__subscription")) update();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", update); else update();
})();
